import UserLoginVerifyPage from "@/features/session/pages/UserLoginVerify";

const UserLoginVerify = () => {
  return <UserLoginVerifyPage />;
};

export default UserLoginVerify;
